import { layoutGutterSmall, sizeGutterSmall } from '@issuu/silkscreen';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import { MAX_CONTENT_WIDTH } from '../../constants';
import { maxSize } from '../../util/ads-utils';
import DocumentContext from '../DocumentPage/DocumentContext';
import { GoogleAdsTemplate } from './GoogleAdsTemplate';

const wideAdSizes = [[300, 600]];
const narrowAdSizes = [[160, 600]];
const [maxWideWidth] = maxSize(wideAdSizes);
const [maxNarrowWidth] = maxSize(narrowAdSizes);

export const SKYSCRAPER_MIN_WIDTH = maxNarrowWidth;

// 1rem can not be parsed correctly. html root font-size is 16px, and didn't change responsively.
const gutterInt = parseInt(layoutGutterSmall, 10);
const Root = styled.div<{ leftOffset: number }>`
    position: absolute;
    top: ${sizeGutterSmall};
    left: ${({ leftOffset }) => leftOffset}px;
    overflow: hidden;
`;

export const WIDE_SKYSCRAPER_QUERY = `
    (min-width: ${MAX_CONTENT_WIDTH + 2 * (maxWideWidth + gutterInt)}px)
`;

const NarrowAd = ({ network }: { network: string }) => {
    return (
        <GoogleAdsTemplate
            adSizes={narrowAdSizes}
            idSuffix="narrowSkyScraper"
            isShowInnerTitle={true}
            network={network}
        />
    );
};

const WideAd = ({ network }: { network: string }) => {
    return (
        <GoogleAdsTemplate
            adSizes={wideAdSizes}
            idSuffix="wideSkyScraper"
            isShowInnerTitle={true}
            network={network}
        />
    );
};

export const AdsSkyScraper: React.FC = () => {
    const [isAdWide, setIsAdWide] = useState(false);
    useEffect(() => {
        const matcher = window.matchMedia(WIDE_SKYSCRAPER_QUERY);
        setIsAdWide(matcher.matches);
        const listener = (event: MediaQueryListEvent) => setIsAdWide(event.matches);
        if ('addEventListener' in matcher) {
            matcher.addEventListener('change', listener);
        } else {
            // Safari < 14 needs this
            matcher.addListener(listener);
        }
        return () => {
            if ('removeEventListener' in matcher) {
                matcher.removeEventListener('change', listener);
            } else {
                // Safari < 14 needs this
                matcher.removeListener(listener);
            }
        };
    }, []);

    const {
        articleStorySummaries,
        publisher: {
            licenses: { docpageAds },
        },
    } = useContext(DocumentContext);

    const network = docpageAds
        ? '/30443627/DocPage_Primary_adConnect'
        : articleStorySummaries.length
        ? '/30443627/DocPage_Sections_Primary'
        : '/30443627/DocPage_Primary';
    const width = isAdWide ? maxWideWidth : maxNarrowWidth;
    const leftOffset = -(width + gutterInt);
    return (
        <Root leftOffset={leftOffset}>
            {isAdWide ? <WideAd network={network} /> : <NarrowAd network={network} />}
        </Root>
    );
};
